import React, { useState } from "react";
import TabPanelCmp from "../../../components/tabPanel/tabPanelCmp";
import { Typography } from "@mui/material";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import DuringCard from "./duringCard";
import Orders from "./orders";
import CheckIcon from '@mui/icons-material/Check';

export default function HistoryList() {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    {
      id: 0,
      key: "inProgress",
      title: <span >در جریان</span>,
      icon: <MoreHorizOutlinedIcon />,
      child: <Orders serviceName="GetInProgressOrders" activeTab={activeTab} />,
    },
    {
      id: 1,
      key: "delivered",
      title: <span>تحویل شده</span>,
      icon: <CheckIcon />,
      child: <Orders serviceName="GetDeliveredOrders" activeTab={activeTab} />,
    },
    {
      id: 2,
      key: "canceled",
      title: <span>لغو شده</span>,
      icon: <CloseOutlinedIcon />,
      child: <Orders serviceName="GetCanceledOrders" activeTab={activeTab} />,
    },
  ];
  return (
    <div>
      <Typography className="colorTitle textFont18" style={{ marginRight: '10px', marginBottom: '18px' }}>
        <b>تاریخچه سفارشات</b>
      </Typography>

      <TabPanelCmp class="tabsScrollDuring" tab={tabs} setActiveTab={setActiveTab} height={"70vh"} from={"historyList"} />
    </div>
  );
}
